module.exports = __webpack_public_path__ + "static/media/Laptop 2.2f1c3d58.png";